import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import messages from '../../assets/Messages.json';
import { generateYearRange, isNumeric } from '../../Custom/Custom';
import asiTitle from '../../asi.json';

const COMPARISON_ITEMS = [
   { id: 1, label: 'Average salaries/wages per man day worked (Rs.) (E6,8/E6,5)' },
   { id: 2, label: 'Total worker (number) (E6,6)' },
   { id: 3, label: 'Total employees (number) (E10,6)' },
   { id: 4, label: 'Total emoluments (E10,8 + E11,8 + E12,8 + E13,8)' },
   { id: 5, label: 'Variation in finished goods (D6,4 - D6,3)' },
   { id: 6, label: 'Working Capital (D16,4)' },
   { id: 7, label: 'Total input (F1,3+F2(i),3+F2(ii),3+F3,3+F4,3+F6,3+F7,3+F8,3+F11,3) (+)(H23,6)(+)(I7,6)' },
   { id: 8, label: 'Total output (J12,7)(-) (J12,8+J12,9+J12,10-J12,11)+(D6,4 - D6,3) +(G1,3+G2,3+G3,3+G4,3+G6,3+G7,3+G8,3+G11,3+F7,3)' },
   { id: 9, label: 'Gross value added (GVA) (Item 8 - Item 7 as above)' },
   { id: 10, label: 'Net value added (Item 9 as above) - Depreciation (C13,9)' },
   { id: 11, label: 'Net Income (Item 10 as above) (-) (F9,3+F10,3)' },
   { id: 12, label: 'Profit (Item 11 as above) (-) (E10,8+E11,8+E12,8+E13,8)' },
   { id: 13, label: 'Actual addition to fixed assets (C13,5)' },
   { id: 14, label: 'GVA (through Ex-factory Value) (J12,13) (+)(G1,3+G2,3+G3,3+G4,3+G6,3+G7,3+G8,3+G11,3+F7,3) (-)(F1,3+F2(i),3+F2(ii),3+F3,3+F4,3+F6,3+F7,3+F8,3+F11,3) (-) (H23,6) (-) (I7,6)' },
];

const buildInitialItemData = () => {
   const initialData = {};
   COMPARISON_ITEMS.forEach((item) => {
      initialData[item.id] = {
         currentYear: '',
         previousYear: '',
         reason: '',
         currentYearClass: 'textBox_back_color_white',
         previousYearClass: 'textBox_back_color_white',
      };
   });
   return initialData;
};

export default function ASIComparision({ blockInfo }) {
   const navigate = useNavigate();
   const [itemData, setItemData] = useState(buildInitialItemData);
   const storedLanguage = localStorage.getItem('language');
   const surveyYear = Number(blockInfo?.surveyYear) || new Date().getFullYear();
   const currentYearRange = generateYearRange(surveyYear);
   const previousYearRange = generateYearRange(surveyYear - 1);

   const handleOnChange = (itemId, field, value) => {
      if (field === 'currentYear' || field === 'previousYear') {
         if (value !== '' && !isNumeric(value)) return;
      }

      setItemData((prev) => ({
         ...prev,
         [itemId]: {
            ...prev[itemId],
            [field]: value,
         },
      }));
   };

   const handleReset = () => {
      setItemData(buildInitialItemData());
   };

   const handleSave = () => {
      toast.success('Comparison Report data saved locally.', messages.COLOR_RED);
   };

   return (
      <div className="card-body">
         <h4 className="page_heading border-bottom-0">
            <div
               dangerouslySetInnerHTML={{
                  __html:
                     storedLanguage === 'hi'
                        ? asiTitle.hi.COMPARISON_REPORT_TITLE
                        : asiTitle.en.COMPARISON_REPORT_TITLE,
               }}
            />
         </h4>

         <div className="row">
            <div className="col-12">
               <h6 className="fw-semibold">
                  {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}:{' '}
                  <span className="fw-normal me-5">{blockInfo?.dslNo || '-'}</span>
                  {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}:{' '}
                  <span className="fw-normal">{currentYearRange}</span>
               </h6>

               <div className="table-responsive asi_block_table">
                  <table cellPadding="0" cellSpacing="0" className="table table-bordered block_c_table">
                     <thead>
                        <tr>
                           <th style={{ width: '4%' }}>
                              {storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}
                           </th>
                           <th style={{ width: '36%' }}>
                              {storedLanguage === 'hi' ? asiTitle.hi.ITEMS : asiTitle.en.ITEMS}
                           </th>
                           <th style={{ width: '15%' }}>
                              {storedLanguage === 'hi'
                                 ? asiTitle.hi.CURRENT_YEAR
                                 : asiTitle.en.CURRENT_YEAR}{' '}
                              ({currentYearRange})
                           </th>
                           <th style={{ width: '15%' }}>
                              {storedLanguage === 'hi'
                                 ? asiTitle.hi.PREVIOUS_YEAR
                                 : asiTitle.en.PREVIOUS_YEAR}{' '}
                              ({previousYearRange})
                           </th>
                           <th style={{ width: '30%' }}>
                              {storedLanguage === 'hi'
                                 ? asiTitle.hi.REASON_FOR_VARIATION
                                 : asiTitle.en.REASON_FOR_VARIATION}
                           </th>
                        </tr>
                        <tr>
                           <th>1</th>
                           <th>2</th>
                           <th>3</th>
                           <th>4</th>
                           <th>5</th>
                        </tr>
                     </thead>
                     <tbody>
                        {COMPARISON_ITEMS.map((item) => (
                           <tr key={item.id}>
                              <td valign="top">{item.id})</td>
                              <td>{item.label}</td>
                              <td className={itemData[item.id].currentYearClass}>
                                 <input
                                    type="text"
                                    className="form-control"
                                    maxLength="19"
                                    value={itemData[item.id].currentYear}
                                    onChange={(e) =>
                                       handleOnChange(item.id, 'currentYear', e.target.value)
                                    }
                                 />
                              </td>
                              <td className={itemData[item.id].previousYearClass}>
                                 <input
                                    type="text"
                                    className="form-control"
                                    maxLength="19"
                                    value={itemData[item.id].previousYear}
                                    onChange={(e) =>
                                       handleOnChange(item.id, 'previousYear', e.target.value)
                                    }
                                 />
                              </td>
                              <td>
                                 <input
                                    type="text"
                                    className="form-control"
                                    maxLength="500"
                                    value={itemData[item.id].reason}
                                    onChange={(e) =>
                                       handleOnChange(item.id, 'reason', e.target.value)
                                    }
                                 />
                              </td>
                           </tr>
                        ))}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>

         <div className="row">
            <div className="col-12">
               <hr />
            </div>

            <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={() => window.print()}
               >
                  Print
                  <i className="fa fa-print ms-1"></i>
               </button>

               {/* <button type="button" className="btn btn_orange me-1" onClick={handleSave}>
                  Save
               </button>

               <button type="reset" className="btn btn_orange me-1" onClick={handleReset}>
                  Reset
               </button> */}

               <button type="button" className="btn btn_orange" onClick={() => navigate('/dashboard')}>
                  Cancel
               </button>
            </div>

            <div className="col-lg-4 text-center text-lg-end">
               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={() => {
                     const confirmed = window.confirm('Have you saved your changes?');
                     if (confirmed) navigate('/BlockN');
                  }}
               >
                  Previous
               </button>
            </div>
         </div>
      </div>
   );
}
